/**
 * Interface for the Edge data. This must be in sync with the backend: "db.php"
 */

interface IEdgeData {
    ID: string;
    Name: string;
    OverrideNames: string[];
    GrossUnitPrice: number | null;
    Materials: any; // The configurator ignores this field
    ProductImage: string;
    Width: number;
    Thickness: number;
    Oriented: number; // TODO: This should be a boolean
    // Shop-árazásból (uc_edgeprices.Status): 1 = elérhető, 2 = csak rendelésre.
    // Csak shop-kontextusú lekérésnél jön vissza, egyébként undefined.
    Status?: number | null;
}

export default IEdgeData;
